import React from 'react'
import cn from 'classnames/bind'

import styles from './plain-text-area.module.scss'
import { dispatchFormChanged } from '../custom-events'

const cx = cn.bind(styles)

export const PlainTextArea = ({
  className,
  error,
  success,
  onChange,
  ...props
}: React.ComponentProps<'textarea'> & { error?: boolean; success?: boolean }) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e)
    dispatchFormChanged()
  }

  return (
    <textarea
      className={cx(styles.textarea, { error, success }, className)}
      onChange={handleChange}
      {...props}
    />
  )
}
